"use client";
import Image from "next/image";
import { IMAGES } from "@/lib/constants";
import styles from "./ImageCarousel.module.css";
import React, { useState, useEffect } from "react";

const images = [IMAGES.carBanner, IMAGES.rbiBanner, IMAGES.businessBanner];

const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className={styles.carousel}>
      <div
        className={styles.slides}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((src, index) => (
          <div className={styles.slide} key={index}>
            <Image src={src} alt={`Slide ${index + 1}`} priority fill={true} />
          </div>
        ))}
      </div>
      <button className={styles.prev} onClick={prevSlide} />
      <button className={styles.next} onClick={nextSlide} />
      <div className={styles.indicators}>
        {images.map((_, index) => (
          <span
            key={index}
            className={`${styles.indicator} ${
              currentIndex === index ? styles.active : ""
            }`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
